<div class="fm-content-wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-sm">
            <app-back-button
              backLink="/app/storybooks"
              [title]="detail()?.title || 'Storybook'"
              [categoryName]="'View-only — download or preview this storybook'"
            ></app-back-button>
          </div>
        </div>
      </div>
    </div>

    @if (hasError() || !detail()) {
      <div class="fm-white-column text-center py-5 mt-4">
        <h4 class="fm-head-24 fm-head-sty2">Couldn't load this storybook</h4>
        <p class="mb-0">Please check your connection and try again.</p>
      </div>
    } @else if (detail(); as d) {
      <div class="row mt-2">
        <!-- Storybook Details + Pages (read-only) -->
        <div class="col-lg-8 col-xxl-8">
          <div class="fm-white-column mb-4">
            <h3 class="fm-head-20 mb-3">Storybook Details</h3>
            <div class="row g-3">
              <div class="col-12 col-sm-6">
                <p class="fm-view-label mb-1">Title</p>
                <p class="fm-view-value mb-0">{{ d.title }}</p>
              </div>
              @if (d.description) {
                <div class="col-12 col-sm-6">
                  <p class="fm-view-label mb-1">Description</p>
                  <p class="fm-view-value mb-0">{{ d.description }}</p>
                </div>
              }
              @if (d.memoryDate) {
                <div class="col-12 col-sm-6">
                  <p class="fm-view-label mb-1">Date of the Memory</p>
                  <p class="fm-view-value mb-0">{{ d.memoryDate | date: 'MMMM dd, yyyy' }}</p>
                </div>
              }
              <div class="col-12 col-sm-6">
                <p class="fm-view-label mb-1">Author</p>
                <p class="fm-view-value mb-0">{{ d.authorName }}</p>
              </div>
            </div>
          </div>

          <div class="fm-white-column">
            <h3 class="fm-head-20 mb-3">Selected Stories ({{ stories().length }})</h3>
            @if (stories().length === 0) {
              <p class="mb-0">This storybook doesn't include any stories yet.</p>
            } @else {
              <div class="row g-3">
                @for (story of stories(); track story.storyId) {
                  <div class="col-12 col-sm-6 mt-4">
                    <div class="fm-stories-blog fm-match-height h-100">
                      <div class="fm-stories-cover">
                        <img
                          class="fm-image"
                          [src]="
                            story.thumbnailUrl ||
                            story.vimeoThumbnailUrl ||
                            'images/stories/stories-post-1.png'
                          "
                          alt="Story Cover Image"
                          onerror="this.src = 'images/stories/stories-post-1.png'"
                        />
                        <span class="fm-tag">{{ formatDuration(story.duration) }}</span>
                      </div>
                      <div class="fm-stories-content">
                        <div class="fm-st-promt-tag">
                          <span class="fm-st-ti">{{ story.categoryName || '—' }}</span>
                          <span class="fm-st-ti fm-light-green">
                            @if (story.mediaTypeName === 'Video') {
                              <img src="images/icons/fm-video-icon-green.svg" class="fm-svg" alt="Video" />
                            } @else if (story.mediaTypeName === 'Audio') {
                              <img src="images/icons/fm-micro-icon.svg" class="fm-svg" alt="Audio" />
                            } @else {
                              <img src="images/icons/fm-camera.svg" class="fm-svg" alt="Media" />
                            }
                            {{ story.mediaTypeName }}
                          </span>
                        </div>
                        <h4 class="fm-head-20 fm-head-sty2">
                          <a [appTooltip]="story.title">{{ story.title }}</a>
                        </h4>
                        <div class="fm-user-profile">
                          <div class="fm-userprofile">
                            <div class="fm-left">
                              <div class="fm-userprofile-image">
                                @if (story.authorPhotoURL) {
                                  <img
                                    class="fm-profile"
                                    [src]="story.authorPhotoURL"
                                    [alt]="story.storyAuthorName || 'Story author'"
                                    onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'"
                                  />
                                  <span class="fm-profile fm-profile-initials" style="display:none;">
                                    {{ getAuthorInitials(story.storyAuthorName) }}
                                  </span>
                                } @else {
                                  <span class="fm-profile fm-profile-initials">
                                    {{ getAuthorInitials(story.storyAuthorName) }}
                                  </span>
                                }
                              </div>
                              <span class="fm-profile-content">
                                <span class="fm-profilename">{{ story.storyAuthorName || 'Story Author' }}</span>
                              </span>
                            </div>
                          </div>
                          @if (story.familyName) {
                            <hr class="my-0" />
                            <p class="fm-black-cl fm-icon-content mb-0 mt-1">
                              <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family" />
                              <span>{{ story.familyName }}</span>
                            </p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Book Preview sidebar -->
        <div class="col-lg-4 col-xxl-4">
          <div class="fm-sidebar-clumn mt-4 mt-lg-0">
            <div class="fm-border-column fm-book-preview-sidebar">
              <h3 class="fm-head-20 fm-sidebar-title mb-0">Book Preview</h3>
              <div class="fm-book-cover-wrap">
                <img
                  [src]="d.coverImageUrl || 'images/storybooks/bookcover-placeholder.png'"
                  class="fm-book-cover-image"
                  alt="Book Cover"
                  onerror="this.src='images/storybooks/bookcover-placeholder.png'"
                />
                <div class="fm-book-cover-overlay">
                  <h4
                    class="fm-book-cover-overlay-title"
                    [class]="getCoverTitleSizeClass(d.title)"
                  >
                    {{ d.title }}
                  </h4>
                  <p class="fm-book-cover-overlay-author">{{ d.authorName }}</p>
                </div>
              </div>
              <div class="fm-book-stats-box mt-3">
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ d.totalStories }}</h4>
                  <p class="mb-0">Total Stories</p>
                </div>
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ d.totalDuration || '0:00' }}</h4>
                  <p class="mb-0">Total Duration</p>
                </div>
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ d.estimatedPages }}</h4>
                  <p class="mb-0">Est. Pages</p>
                </div>
              </div>
              <div class="fm-book-includes mt-4">
                <p>This Storybook Includes:</p>
                <div class="fm-book-include-item">
                  <div class="fm-book-include-icon">
                    <img src="images/icons/fm-photo.svg" class="fm-svg" alt="Photos Icon" />
                  </div>
                  <div>
                    <p class="fm-include-title mb-0">Photos & Images</p>
                    <p class="fm-include-text mb-0">Beautiful memories in every page</p>
                  </div>
                </div>
                <div class="fm-book-include-item mt-4">
                  <div class="fm-book-include-icon">
                    <img src="images/icons/fm-ai.svg" class="fm-svg" alt="AI Icon" />
                  </div>
                  <div>
                    <p class="fm-include-title mb-0">AI-Formatted Text</p>
                    <p class="fm-include-text mb-0">Structured stories, beautifully formatted</p>
                  </div>
                </div>
                <div class="fm-book-include-item mt-4">
                  <div class="fm-book-include-icon">
                    <img src="images/icons/fm-qr.svg" class="fm-svg" alt="QR Icon" />
                  </div>
                  <div>
                    <p class="fm-include-title mb-0">QR Codes to Videos</p>
                    <p class="fm-include-text mb-0">Scan to instantly watch your stories anytime</p>
                  </div>
                </div>
              </div>

              <div class="row g-3 mt-2">
                <div class="col-12">
                  <button
                    type="button"
                    class="fm-common-btn fm-sm-btn w-100"
                    [disabled]="isLoadingPreview()"
                    (click)="previewStorybook()"
                  >
                    {{ isLoadingPreview() ? 'Loading…' : 'Preview Book' }}
                    <img src="images/icons/fm-eye-white.svg" class="fm-svg" alt="Preview Icon" />
                  </button>
                </div>
                <div class="col-12">
                  <button
                    type="button"
                    class="fm-common-btn fm-secondary-btn fm-sm-btn fm-white-btn-txt w-100"
                    [disabled]="exportingType() !== null"
                    (click)="exportStorybook(StorybookExportType.Pdf)"
                  >
                    {{ exportingType() === StorybookExportType.Pdf ? 'Downloading…' : 'Download PDF' }}
                    <img
                      src="images/icons/fm-download-white.svg"
                      class="fm-svg"
                      alt="Download Icon"
                    />
                  </button>
                </div>
              </div>
              <div class="row g-3 mt-2">
                <div class="col-12">
                  <button
                    type="button"
                    class="fm-common-btn fm-border-btn fm-sm-btn w-100"
                    [disabled]="exportingType() !== null"
                    (click)="exportStorybook(StorybookExportType.Doc)"
                  >
                    {{ exportingType() === StorybookExportType.Doc ? 'Exporting…' : 'Export DOCX' }}
                    <img
                      src="images/icons/fm-doc.svg"
                      class="d-lg-none d-xxl-inline"
                      alt="Export Icon"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

@if (previewData(); as preview) {
  <app-storybook-preview-modal [data]="preview" (closed)="closePreview()" />
}
